import { callServiceMachine } from '_core/util';
import Machines from '../Machines';
import { ChangePasswordTypes } from '../Types';

const machine = Machines.onChangePassword.machine;

export const changePassword = (
  params: ChangePasswordTypes.ChangePasswordServiceRequestType,
): Promise<ChangePasswordTypes.IChangePasswordServiceResponse> => {
  return callServiceMachine(machine, params);
};

export default { changePassword };
